
import { Button } from "@/components/ui/button";
import { Lock } from "lucide-react";
import { AnimatedSubmitButton } from "./AnimatedSubmitButton";

interface SubmitButtonProps {
    hasPaid: boolean;
    isSubmitting: boolean;
    onSubmit: () => void;
    onSubscribe: () => void;
}

export const SubmitButton = ({
    hasPaid,
    isSubmitting,
    onSubmit,
    onSubscribe
}: SubmitButtonProps) => {
    if (hasPaid) {
        return (
            <AnimatedSubmitButton 
                isSubmitting={isSubmitting}
                onSubmit={onSubmit}
                className="submit-button"
            />
        );
    }

    return (
        <Button onClick={onSubscribe} className="submit-button">
            <Lock className="mr-2 h-4 w-4" />
            Unlock Full Access
        </Button>
    );
};
